import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export function FinalCTA() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="h-screen flex items-center justify-center px-4 scroll-snap-align-start">
      <div
        ref={ref}
        className={`max-w-2xl mx-auto text-center ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`}
      >
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-foreground tracking-tight mb-6">
          Built by radiologists. For radiologists.
        </h2>
        <p className="text-lg text-muted-foreground font-light mb-12">
          No gimmicks. No hallucinations. Just tools that respect judgment, reduce risk, and let expertise compound.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Link to="/waitlist">
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground px-8">
              Join the Waitlist
            </Button>
          </Link>
          <Link to="/login">
            <Button size="lg" variant="outline" className="px-8">
              Already have an invite?
            </Button>
          </Link>
        </div>

        {/* Security badges */}
        <div className="flex items-center justify-center gap-6 text-xs text-muted-foreground">
          <span className="border border-border/50 rounded px-3 py-1">Security-First Architecture</span>
          <span className="border border-border/50 rounded px-3 py-1">HIPAA-Aligned Workflows</span>
        </div>
      </div>
    </section>
  );
}
